AGADash.Bars = (function () {
    return {
        render: function (body, data) {
            AGADash.BarsAndStack.render(body, data, false);
        }
    };
})();

AGADash.Repository.register(102, AGADash.Bars);